module.exports = __webpack_public_path__ + "static/media/cyberpunk.eb47bd03.png";